import { useCallback, useState } from 'react';

const STORAGE_KEY = 'admin-sidebar-mode';

export type SidebarMode = 'focused' | 'full';

function getStoredMode(): SidebarMode {
	if (typeof window === 'undefined') return 'full';
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (raw === 'focused' || raw === 'full') return raw;
		// Default: show favorites mode if user has favorites, otherwise all tabs
		const favs = window.localStorage.getItem('admin-sidebar-favorites');
		if (favs) {
			try {
				const parsed = JSON.parse(favs);
				if (Array.isArray(parsed) && parsed.length > 0) return 'focused';
			} catch { /* fall through */ }
		}
		return 'full';
	} catch {
		return 'full';
	}
}

export function useAdminSidebarMode() {
	const [mode, setModeState] = useState<SidebarMode>(getStoredMode);

	const setMode = useCallback((next: SidebarMode) => {
		try {
			window.localStorage.setItem(STORAGE_KEY, next);
			setModeState(next);
		} catch {
			// ignore
		}
	}, []);

	return { mode, setMode };
}
